<template>
  <main>
    <mdb-container>
      <h1 class="sr-only">{{ $t('boards.heading') }}</h1>
      <content-status
        v-if="!hasBoards"
        :empty-message="$t('boards.empty')"
        :error-message="$t('boards.load_error')"
        :failed="boards.error"
        :loading="isLoading"
        :loading-label="$t('site.loading')"
        @retry="load"
      />

      <template v-else>
        <section v-if="current.length" data-section="current">
          <section-divider :title="$t('boards.current_heading')" variant="crimson"/>
          <mdb-row>
            <Bestuur
              v-for="(board, index) in current"
              :key="`current-${index}`"
              :name="board.name"
              :year="board.period"
              :preases="board.preases"
              :abactis="board.abactis"
              :questor="board.questor"
              variant="current"
              col-size="12"
            />
          </mdb-row>
        </section>

        <section v-if="former.length" data-section="former">
          <section-divider :title="$t('boards.former_heading')" variant="forest"/>
          <mdb-row>
            <Bestuur
              v-for="(board, index) in former"
              :key="`former-${index}`"
              :name="board.name"
              :year="board.period"
              :preases="board.preases"
              :abactis="board.abactis"
              :questor="board.questor"
              col-size="12"
            />
          </mdb-row>
        </section>
      </template>
    </mdb-container>
  </main>
</template>

<script>
import { mdbRow, mdbContainer } from 'mdbvue';
import { mapState } from 'vuex';
import Bestuur from '../components/Bestuur.vue';
import ContentStatus from '../components/ContentStatus.vue';
import SectionDivider from '../components/SectionDivider.vue';

export default {
  name: 'Besturen',
  components: {
    mdbRow,
    mdbContainer,
    Bestuur,
    ContentStatus,
    SectionDivider,
  },
  computed: {
    ...mapState('intro', ['boards']),
    current() {
      return this.boards.data ? this.boards.data.current : [];
    },
    former() {
      return this.boards.data ? this.boards.data.former : [];
    },
    hasBoards() {
      return this.current.length > 0 || this.former.length > 0;
    },
    // The request starts in created(), so "no data and no error" can only mean it is on its way.
    isLoading() {
      return !this.boards.data && !this.boards.error;
    },
  },
  created() {
    this.$store.commit('TOGGLE_OFF_NAVBAR_TRANSPARENT');
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch('intro/fetchBoards');
    },
  },
};
</script>
